<template>
  <v-card class="dash-section" elevation="0">
    <div class="dash-section-header">
      <div class="dash-section-badge">
        <v-icon color="white">mdi-clipboard-text-outline</v-icon>
      </div>
      <h2 class="dash-section-title">Assessment Centre Updates</h2>
    </div>

    <div class="dash-grid">
      <summary-card
        v-for="(item, index) in summaries"
        :key="index"
        :count="item.count"
        :title="item.title"
        :category="item.category"
        :icon="item.icon"
        :loading="isLoading"
      ></summary-card>
    </div>

    <v-divider class="dash-divider"></v-divider>
    <div class="dash-updated">
      <v-icon color="primary" size="18">mdi-clock-time-four</v-icon>
      <span>Just Updated</span>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {
    SummaryCard: () => import('@/components/dashboard/SummaryCard'),
  },
  props: {
    summary: {
      type: Object,
      default: () => ({
        bookedVehicles: 0,
        supplementaryReceived: 0,
        submittedBids: 0,
        approvedBids: 0,
        writeOf: 0,
        belowExcess: 0,
        cashInLieu: 0,
        declined: 0,
        undocumented: 0,
        underInvestigation: 0,
        checkedOut: 0,
      }),
    },
    isLoading: { type: Boolean, required: true },
  },
  computed: {
    summaries() {
      return [
        {
          count: this.summary.bookedVehicles,
          title: 'No. of Vehicles Booked',
          category: 'VEHICLES_BOOKED',
          icon: 'mdi-calendar-check',
        },
        {
          count: this.summary.submittedBids,
          title: 'No. of Bid Received',
          category: 'BIDS_SUBMITTED',
          icon: 'mdi-gavel',
        },
        {
          count: this.summary.supplementaryReceived,
          title: 'Supplementaries Received',
          category: 'SUPPLEMENTARY_RECEIVED',
          icon: 'mdi-file-plus-outline',
        },
        {
          count: this.summary.approvedBids,
          title: 'No. of Approved Bids',
          category: 'APPROVED_BIDS',
          icon: 'mdi-check-decagram',
        },
        {
          count: this.summary.cashInLieu,
          title: 'No. of Cash in Lieu',
          category: 'CASH_IN_LIEU',
          icon: 'mdi-cash-multiple',
        },
        {
          count: this.summary.belowExcess,
          title: 'No. of Below Excess',
          category: 'BELOW_EXCESS',
          icon: 'mdi-cash-minus',
        },
        {
          count: this.summary.writeOf,
          title: 'No. of Write Offs',
          category: 'WRITE_OFF',
          icon: 'mdi-car-off',
        },
        {
          count: this.summary.declined,
          title: 'Declined Claims',
          category: 'DECLINED',
          icon: 'mdi-close-circle-outline',
        },
        {
          count: this.summary.underInvestigation,
          title: 'Vehicles under investigation',
          category: 'UNDER_INVESTIGATIONS',
          icon: 'mdi-file-search-outline',
        },
        {
          count: this.summary.undocumented,
          title: 'Undocumented Claims',
          category: 'UNDOCUMENTED',
          icon: 'mdi-file-alert-outline',
        },
        {
          count: this.summary.checkedOut,
          title: 'No. of Checked Out Vehicles',
          category: 'CHECKED_OUT',
          icon: 'mdi-car-key',
        },
      ]
    },
  },
}
</script>

<style scoped>
.dash-section {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px;
}
.dash-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.dash-section-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.dash-section-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.dash-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}
@media (min-width: 600px) {
  .dash-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 960px) {
  .dash-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1264px) {
  .dash-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
.dash-divider {
  margin: 16px 0 0;
}
.dash-updated {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 10px;
  font-size: 13px;
  color: #6b7684;
}
</style>
